
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "TableHeader",
})
export default class extends Vue {
  @Prop({ type: Number, default: 0 })
  private count: number;

  @Prop(Boolean)
  private show: Boolean;

  viewMessage() {
    console.log('message')
    this.$emit('message');
  }
}
